/**
 * Generated from com.dataiku.dip.eda.compute.stats.PValueAdjustmentMethod
 */
export enum PValueAdjustmentMethod {
    BONFERRONI = 'BONFERRONI',
    NONE = 'NONE',
    HOLM_BONFERRONI = 'HOLM_BONFERRONI'
}